import React, { useState } from 'react'
import Button from 'antd/lib/button'
import lambdaInvokeAdditionalOccupancies from '../../../lib/LambaInvokeAdditionalOccupancies'
import Overlay from '../../Overlay'
import { useSelector } from 'react-redux'
import { setShowPopUp } from '../../../redux/auth/actions'
import { message } from 'antd'

const styles = {
    container: {
        minHeight: 200,
        width: 500,
        padding: '1em',
    },
    header: {
        fontSize: 32,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '1.5em',
    },
    actions: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '1.5em',
    },
}

const ExtraOccupancies = ({ backToSignIn, attr }) => {

    const [loading, setLoading] = useState(false)

    const showPopUp = useSelector(state => state.auth.showPopUp)
    const tenant = useSelector(state => state.auth.tenant)

    const handleSubmit = () => {
        setLoading(true)
        lambdaInvokeAdditionalOccupancies(attr)
            .then((response) => {
                if (response) {
                    message.success("Association saved succesfully")
                    backToSignIn()
                } else {
                    console.log("else")
                }
                setLoading(false)
            }).catch(err => {
                console.log("add error: ", err)
            })
    }

    return (
        <Overlay
            onClose={() => setShowPopUp(false)}
            visible={showPopUp}
            headerText={'Add Additional'}
            closebutton={true}>
            <div style={styles.container}>
                <div style={styles.content}>
                    <div style={styles.info}>
                        <p>You are an occupant in another tenant</p>
                        <p>Do you want to add yourself to {tenant.tenant.name}</p>
                    </div>
                    <div style={styles.actions}>
                        <Button htmlType="button" size="large" onClick={() => setShowPopUp(false)}>
                            Cancel
                        </Button>
                        <Button loading={loading} type="primary" htmlType="button" size="large" onClick={handleSubmit}>
                            Add
                        </Button>
                    </div>
                </div>
            </div>
        </Overlay>
    )
}

export default ExtraOccupancies
